import sdks, { EVENTS } from '@/utils/_sasdk'
import cookie from 'js-cookie'

// 注册公共属性
sdks.registerPage({
  object_version: 'v1.0.0',
  business: 'VIPKIDmath',
  object: 'MathGrowth',
  app_id: '703dc5d1afbb9d76',
  student_id: cookie.get('mbstudentid') || '',
  parent_id: cookie.get('mbparentid') || ''
})

const sasdk = Object.assign({
  viewindex () {
    this.track(EVENTS.page, {
      event_id: 'MathREF_View',
      str1: '用户访问首页'
    })
  },
  // getfreecode () {
  //   this.track(EVENTS.click, {
  //     event_id: 'MathLandingPage_getFreeCode_click',
  //     str1: '手机号输入后点击“免费领取数学思维课”'
  //   })
  // },
  getfree () {
    this.track(EVENTS.click, {
      event_id: 'MathREF_getFree_click',
      str1: '验证码输入后点击“免费领取数学思维课”'
    })
  },
  receive () {
    this.track(EVENTS.click, {
      event_id: 'MathREF_receive_click',
      str1: '学生领取'
    })
  },
  viewsuccess () {
    this.track(EVENTS.page, {
      event_id: 'MathREF_SuccessfulPage_View',
      str1: '成功领取页'
    })
  },
  viewfail () {
    this.track(EVENTS.page, {
      event_id: 'MathREF_FailedPage_View',
      str1: '重复领取页'
    })
  }
}, sdks)

export default sasdk
